<template>
  <div>
    <b-container fluid="xl" class="bg-img">
      <b-row class="justify-content-end">
        <b-col
          md="6"
          sm="12"
          class="minh-100 mobile-hidden d-flex flex-direction-column justify-content-center align-items-center"
        >
          <div class="d-none d-md-block">
            <div class="text-center">
              <img
                :src="`${publicPath}/img/rcp/${theme}-white-logo.png`"
                class="mx-50"
              />
              <h2 class="welcome-title" v-html="$t(captionAuth)"></h2>
              <p class="welcome-desc">
                {{ $t(subCaptionAuth) }}
              </p>
            </div>
          </div>
        </b-col>
        <b-col
          md="5"
          sm="12"
          class="minh-100 d-flex justify-content-center align-items-center my-4"
        >
          <div class="bg-white sign-in-card p-relative">
            <div class="d-flex">
              <DropdownLanguage
                v-if="this.translation == 1"
                class="ml-auto"
                @set-language = "setLanguage"
              ></DropdownLanguage>
            </div>
            <img
              :alt="theme"
              :src="`${publicPath}/img/rcp/${theme}-logo.png`"
              class="company-logo mr-3"
            />
            <img
              v-if="company_logo"
              alt="Gvv Logo"
              :src="`${publicPath}/img/rcp/${company_logo}.png`"
            />
            <div class="mb-3">
              <div class="mb-1 fz-31 mt-4 fw-700">
                {{ $t("Let's Sign In") }}
              </div>
              <div class="text-muted fz-16 fw-400">
                {{
                  $t("Please fill all the fields to get inside the system.")
                }}
              </div>
            </div>
            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <b-form
                role="form"
                @submit.prevent="handleSubmit(onSubmit)"
                id="formLogin"
                class="mt-5"
              >
                <div
                  class="input-group input-group-alternative form-group form-floating mb-5"
                >
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <img :src="`${publicPath}/img/rcp/user.svg`" />
                    </div>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    v-model="username"
                    name="Username"
                    id="username"
                    :placeholder="$t('Username')"
                    @keydown="onChange('username')"
                    v-uppercase
                  />
                  <label for="text">{{ $t("Username") }}</label>
                  <div
                    v-if="error.username"
                    class="invalid-feedback d-block mb-3"
                  >
                    {{ $t(error.username) }}
                  </div>
                </div>
                <div class="form-group form-floating position-relative">
                  <base-input
                    alternative
                    class="mb-0"
                    id="Password"
                    name="Password"
                    prepend-icon="ni ni-lock-circle-open"
                    :type="show_password ? 'text' : 'password'"
                    :placeholder="$t('Password')"
                    v-model="password"
                    @keydown="onChange"
                  >
                    <template v-slot:prepend>
                      <img :src="`${publicPath}/img/rcp/password.svg`" />
                    </template>
                    <template v-slot:append>
                      <a
                        class="btn-action"
                        @click.prevent="toggleShow('password')"
                      >
                        <i
                          class="far pl-2 pr-2"
                          :class="{
                            'fa-eye-slash': show_password,
                            'fa-eye': !show_password,
                          }"
                        ></i>
                      </a>
                    </template>
                  </base-input>
                  <label for="text">{{ $t("Password") }}</label>
                  <div
                    v-if="error.password"
                    class="invalid-feedback d-block mb-3"
                  >
                    {{ $t(error.password) }}
                  </div>
                </div>

                <div class="text-right mb-2">
                  <a
                    href="#"
                    @click.prevent="gotoForgot"
                    class="fz-14 fw-400 blue-font"
                    >{{ $t("Forget Password?") }}</a
                  >
                </div>

                <div class="text-center">
                  <base-button
                    type="primary"
                    pill
                    native-type="submit"
                    class="my-4 fz-19 fw-600"
                    >{{ $t("Sign in") }}</base-button
                  >
                </div>
              </b-form>
            </validation-observer>
            <div v-if="isAllowRegis()" class="register-bottom fz-14 fw-400">
              <div
                v-if="!complete_regis || complete_regis != 'complete'"
                class="mb-4"
              >
                {{ $t("Do not have an account?") }}
                <a
                  href="#"
                  @click.prevent="gotoRegister"
                  class="fz-14 fw-600 blue-font"
                  >{{ $t("Register") }}!</a
                >
              </div>
              <div
                v-if="complete_regis == 'complete'"
                class="mb-4 complete-regis"
              >
                <span class="text-grey2 mr-2"
                  >{{ $t("Didn't receive the email") }} ?
                </span>
                <a
                  href="#"
                  @click.prevent="gotoResendEmail"
                  class="fz-14 fw-600 text-blue2"
                  >{{ $t("Resend email") }}</a
                >
              </div>
            </div>

            <a
              v-if="isShowWaLink()"
              href="https://api.whatsapp.com/send/?phone=60108929399"
              target="_blank"
              class="position-absolute bottom-0 right-0 mr-5"
            >
              <img :src="`${publicPath}/img/rcp/-wa.png`" width="40" />
            </a>
           
          </div>
        </b-col>
      </b-row>
    </b-container>

    <PopupConfirmation
      :token="this.$route.query.verification"
      @token-verified="isLoading = false"
    ></PopupConfirmation>
    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>
import Auth from "@/services/Auth";
import Common from "@/services/Common";
import PopupConfirmation from "@/components/PopupConfirmation";
import LoaderComponent from "@/components/LoaderComponent";
import DropdownLanguage from "@/components/DropdownLanguage.vue";

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      translation: process.env.VUE_APP_TRANSLATION,
      domain: process.env.VUE_APP_DOMAIN,
      wa_link: JSON.parse(process.env.VUE_APP_WALINK),
      company_logo: "",
      list_logo: JSON.parse(process.env.VUE_APP_COMPANY_LOGO),
      register: JSON.parse(process.env.VUE_APP_REGISTER),
      captionAuth:process.env.VUE_APP_CAPTION_AUTH,
      subCaptionAuth:process.env.VUE_APP_SUB_CAPTION_AUTH,
      theme:process.env.VUE_APP_THEME,
      complete_regis: "",
      username: "",
      password: "",
      show_password: false,
      isLoading: false,
      error: {
        username: "",
        password: "",
      },
    };
  },
  components: { PopupConfirmation, LoaderComponent, DropdownLanguage },
  methods: {
    isAllowRegis() {
      let check = true;
      Object.keys(this.register).forEach((key) => {
        if (
          window.location.hostname.indexOf(key) != -1 &&
          this.register[key] == 0
        ) {
          check = false;
        }
      });

      return check;
    },
    isShowWaLink() {
      let check = false;
      Object.keys(this.wa_link).forEach((key) => {
        if (
          window.location.hostname.indexOf(key) != -1 &&
          this.wa_link[key] == 1
        ) {
          check = true;
        }
      });

      return check;
    },
    setLanguage(param) {
      localStorage.setItem("lang", param);
      localStorage.setItem("lang-key", param);
      this.$i18n.locale = this.param;

      const self = this;
      self.$notify({
        type: "success",
        text: self.getMessage("Successfully change default language"),
      });

      setTimeout(function () {
        location.reload();
      }, 500);
    },
    getMessage: function (key) {
      return this.$t(key);
    },
    toggleShow(name) {
      this["show_" + name] = !this["show_" + name];
    },
    gotoResendEmail() {
      this.$router.push({ path: "/resend-email" });
    },
    gotoForgot: function () {
      this.$router.push({ path: "/forgot-password" });
    },
    gotoRegister: function () {
      this.$router.push({ path: "/register" });
    },
    onChange: function () {
      Object.keys(this.error).forEach((key) => {
        this.error[key] = "";
      });
    },
    iframeEvent: function (e) {
      if (e.data && (typeof e.data === "string" || e.data instanceof String)) {
        const data = JSON.parse(e.data);
        this.afterLogin(data);
      }
    },
    inIframe: function () {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    afterLogin: function (data) {
      const self = this;
      localStorage.setItem("isFirstTime", data.status_login);
      localStorage.setItem("member", btoa(data.id));
      localStorage.setItem("token", data.token);
      localStorage.setItem("init", true);

      this.isLoading = false;

      if (this.translation == 1) {
        Common.profile().then((response) => {
          if (response.status == 200) {
            const profile = response.data.data;

            if (profile.language && profile.language != null) {
              // localStorage.setItem("lang", profile.language);
              // localStorage.setItem("lang-key", profile.language);
              // this.$i18n.locale = profile.language;
            }
            if (this.domain == 1) {
              window.parent.location.href = data.domain;
            } else {
              this.$router.push({ path: "/" });
            }
          }
        });
      } else if (this.domain == 1) {
        window.parent.location.href = data.domain;
      } else {
        this.$router.push({ path: "/" });
      }
    },
    onSubmit: async function () {
      this.isLoading = true;
      const data = { username: this.username, password: this.password };

      await Auth.login(data)
        .then((response) => {
          if (response.status == 200) {
            const data = response.data;
            const isFirstTime =
              data.status_login &&
              (data.status_login == "first_login" ||
                data.status_login == "forget-password")
                ? data.status_login
                : false;

            if (data.domain && this.domain == 1) {
              const url =
                data.domain.indexOf("https") == -1 ||
                data.domain.indexOf("http") == -1
                  ? "https://" + data.domain
                  : data.domain;

              if (data.domain.indexOf(window.location.hostname) == -1) {
                let iframe = document.createElement("iframe");
                iframe.onload = function () {
                  const wind = iframe.contentWindow;
                  const post = {
                    status_login: isFirstTime,
                    domain: url,
                    id: data.id,
                    token: data.token,
                  };
                  wind.postMessage(JSON.stringify(post), "*");
                };
                iframe.src =
                  url + "/login?rand=" + Math.round(Math.random() * 10000000);
                document.body.appendChild(iframe);
              } else {
                data.status_login = isFirstTime;
                this.afterLogin(data);
              }
            } else {
              data.status_login = isFirstTime;
              this.afterLogin(data);
            }
          } else {
            this.isLoading = false;
            this.$notify({ type: "error", text: response.data.message });
          }
        })
        .catch((err) => {
          this.isLoading = false;
          const response = err.response;

          if (typeof err === "string" || err instanceof String) {
            this.$notify({
              type: "error",
              text: "Oppss.. Something wrong, please contact admin",
            });
          } else if (response.status == 400) {
            if (response.data.data) {
              Object.keys(response.data.data).forEach((key) => {
                this.error[key] = response.data.data[key][0];
              });
            } else {
              this.error.password = response.data.message;
            }
          } else {
            this.error.password = err.message;
          }
        });
    },
  },
  mounted() {
    this.complete_regis = this.$route.query.register;

    if (this.$route.query.verification) {
      this.isLoading = true;
    }

    const domain_url = process.env.VUE_APP_CURRENT_DOMAIN
      ? process.env.VUE_APP_CURRENT_DOMAIN
      : location.protocol + "//" + window.location.hostname;

    Object.keys(this.list_logo).forEach((key) => {
      if (domain_url.indexOf(key) != -1) {
        this.company_logo = this.list_logo[key];
      }
    });

    if (this.domain == 1) {
      window.addEventListener("message", this.iframeEvent, false);
    }
  },
};
</script>

<style scoped>
.position-relative {
  position: relative;
}
.complete-regis {
  display: flex;
  align-items: center;
  justify-content: center;
}
.complete-regis::before,
.complete-regis::after {
  content: " ";
  height: 1px;
  width: 53px;
  background: #d9d9d9;
  margin-left: 28px;
  margin-right: 28px;
}
.register-bottom a.text-blue2 {
  color: #0972d3 !important;
}
</style>
